import React from 'react';
import { IconName } from '@blueprintjs/icons';
import { IntlShape, useIntl } from 'react-intl';
import { IProduct, ProductType } from '../../stores';

export const getProductTypeTitle = (
  intl: IntlShape,
  productType: ProductType
) =>
  productType === ProductType.GOOD
    ? intl.formatMessage({ defaultMessage: 'good' })
    : productType === ProductType.PACKAGE
    ? intl.formatMessage({ defaultMessage: 'bundle' })
    : productType === ProductType.SERVICE
    ? intl.formatMessage({ defaultMessage: 'service' })
    : productType;

export const getProductTypeIconName = (productType: ProductType): IconName =>
  productType === ProductType.GOOD
    ? 'barcode'
    : productType === ProductType.PACKAGE
    ? 'box'
    : productType === ProductType.SERVICE
    ? 'box'
    : 'dot';

export const ProductTypeTitle = ({ product }: { product: IProduct }) => {
  const intl = useIntl();
  return <>{getProductTypeTitle(intl, product.type)}</>;
};
